import layers from '@/helpers/data_layers/layers.js';

const loadLayers = async () => {
    return {data: layers};
};

const loadWaterSupplyLayers =  async () => {
    return {data: layers["water_supply"]};
}

export {
    loadLayers,
    loadWaterSupplyLayers
}